import { combineReducers } from '@reduxjs/toolkit';

import headersReducer from './headers';
import annotationsReducer from './annotations';
import loadingFilesReducer from './loadingFiles';
import aggregationsReducer from './aggregations';

const reducers = combineReducers({
    loadingFiles: loadingFilesReducer,
    info: combineReducers({
        headers: headersReducer,
        annotations: annotationsReducer,
        aggregations: aggregationsReducer,
    }),
});

export default reducers;
